export default __webpack_public_path__ + "static/media/finnoNewLogo.6b0cef1e.png";